import Modal from 'react-bootstrap/Modal'
import { Form, Formik } from "formik";
import { TextField } from "../../components/common/TextField/TextField";
import React, { useEffect, useState } from "react";
import { OptionList } from "../../components/common/OptionList/OptionList";
import { Col, Row } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import dateFormat from "dateformat";
import { DateRangePickerComponent, TimePickerComponent } from "@syncfusion/ej2-react-calendars";
import { dateFormatToDb, filesTo } from "../../api/api";
import style from './AddDataModal.Module.css'
import ShowNotification from "../../components/common/Notification/ShowNotification";


const AddDataModal = ({ show, groups, productTypes, eventTypes, addProductTh, setIsCreateProduct, ...props }) => {
    const [fromdate, setFromDate] = useState(dateFormat(new Date(), "yyyy-mm-dd"));
    const [todate, setToDate] = useState(dateFormat(new Date(), "yyyy-mm-dd"));

    const [fromHour, setFromHour] = useState("00:00:00");
    const [toHour, setToHour] = useState("00:00:00");

    const [fileUploadClicked, setFileUploadClicked] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false);
    let [content, setContent] = useState("");
    let [selectedFile, setSelectedFile] = useState();
    let [imageUrl, setImageUrl] = useState("");

    let [productTyp, setProductType] = useState("");
    let [eventTyp, setEventType] = useState("");

    let [showModal, setShowModal] = useState(show);
    // useEffect(()=>{
    //     console.log(productTypes)
    //     console.log(eventTypes)
    // },[])
    const handleClose = () => {
        setShowModal(false);
        setIsCreateProduct(false);
    };

    const saveCkEditorHTML = (e, editor) => {
        setContent(editor.getData());
    };

    const UploadFile = async (file) => {
        if (!file) {
            ShowNotification("Xəbərdarlıq", "Zəhmət olmasa əvvəlcə fayl seçin", "warning");
            return;
        }
        setFileUploadClicked(true);
        setSubmitClicked(false);
        const responseFileLoad = await filesTo.add(file, "products");
        if (responseFileLoad && responseFileLoad.status === 200) {
            ShowNotification("Success", "File uploaded", "success");
            const filePath = "files/" + responseFileLoad.data.url;
            setImageUrl(filePath);
        } else {
            ShowNotification("Error", responseFileLoad?.data?.message || "Fayl yüklənmədi", "danger");
        }
    };

    useEffect(() => {
        if (show) setShowModal(true);
        else setShowModal(false);
    }, [show]);

    let productInstance = {
        title: "",
        content: "",
        imgUrl: "",
        youtubeLink: "",
        status: 1,
        productType: 1,
        eventType: 1,
        price: "",
        startDate: "",
        endDate: "",
    };

    return (
        <Formik
            initialValues={{
                title: "",
                youtubeLink: "",
                price: "",
            }}
            onSubmit={(formValues) => {
                if (submitClicked) {
                    let startDateM = dateFormatToDb(fromdate);
                    let endDateM = dateFormatToDb(todate);

                    productInstance.title = formValues.title;
                    productInstance.content = content;
                    productInstance.imgUrl = imageUrl;

                    productInstance.youtubeLink = formValues.youtubeLink
                        ? formValues.youtubeLink.replace("watch?v=", "embed/")
                        : "";

                    productInstance.status = 1;
                    productInstance.productType = parseInt(productTyp) || 1;
                    productInstance.eventType = parseInt(eventTyp) || 1; // Seçilmiş Tədbir Növü Integer olaraq göndərilir
                    productInstance.price = formValues.price;
                    productInstance.startDate = startDateM + " " + fromHour;
                    productInstance.endDate = endDateM + " " + toHour;

                    addProductTh(productInstance);
                    setIsCreateProduct(false);
                }
            }}
        >
            {props => (
                <Modal show={showModal} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Məhsul əlavə et</Modal.Title>
                    </Modal.Header>
                    <Form>
                        <Modal.Body>
                            <TextField label="Məhsulun Adı" name="title" type="text" enableLabel='true' />

                            <div className="form-group mt-2">
                                <label>Kontent</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={content || ""}
                                    name="content"
                                    onChange={saveCkEditorHTML}
                                />
                            </div>

                            <label className="mt-3">Tarix aralığı</label>
                            <Row className="col-12 mr-2 m-0 p-0 align-items-center">
                                <Col xs={6}>
                                    <div className="col-12 align-self-end m-0 p-0">
                                        <DateRangePickerComponent
                                            id="daterangepicker"
                                            format='dd/MM/yyyy'
                                            name="daterangepicker"
                                            onChange={(event) => {
                                                if (event.value && event.value.length === 2) {
                                                    let startDate = event.value[0];
                                                    let endDate = event.value[1];

                                                    setFromDate(dateFormat(startDate, "dd-mm-yyyy"));
                                                    setToDate(dateFormat(endDate, "dd-mm-yyyy"));
                                                }
                                            }}
                                            placeholder='Gün aralığı seç'
                                        />
                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <div>
                                        <Row>
                                            <Col>
                                                <Row>
                                                    <span className="badge badge-light mt-2 pt-2">from</span>
                                                    <Col className={`mt-2 m-0 p-0 ${style.times}`}>
                                                        <TimePickerComponent
                                                            name="fromHour"
                                                            onChange={(event) => {
                                                                let timeFrom = event.target.value;
                                                                if (timeFrom !== null) {
                                                                    timeFrom = timeFrom.toString().substr(16, 8);
                                                                    setFromHour(timeFrom);
                                                                }
                                                            }}
                                                            value={fromHour}
                                                            format={'HH:mm'}
                                                            placeholder="saat"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Row>
                                                    <span className="badge badge-light mt-2 pt-2">to</span>
                                                    <Col className={`mt-2 m-0 p-0 ${style.times}`}>
                                                        <TimePickerComponent
                                                            name="toHour"
                                                            onChange={(event) => {
                                                                let timeTo = event.target.value;
                                                                if (timeTo !== null) {
                                                                    timeTo = timeTo.toString().substr(16, 8);
                                                                    setToHour(timeTo);
                                                                }
                                                            }}
                                                            value={toHour}
                                                            format={'HH:mm'}
                                                            placeholder="saat"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            {/*<OptionList*/}
                            {/*    label="Status"*/}
                            {/*    data={statList}*/}
                            {/*    name='status'*/}
                            {/*    selectedItem={status}*/}
                            {/*    setData={setStatus}*/}
                            {/*/>*/}
                            {/* DÜZƏLİŞ: Sahə və Tədbir növü yan-yana gələcək şəkildə nizamlandı */}
                            <Row className="mt-3">
                                <Col md={6}>
                                    <OptionList
                                        label="Daxil Olduğu Sahə (Product Type)"
                                        data={productTypes}
                                        selectedItem={productTyp}
                                        name='productType'
                                        setData={setProductType}
                                    />
                                </Col>
                                <Col md={6}>
                                    <OptionList
                                        label="Tədbir Növü (Event Tsype)"
                                        data={eventTypes}
                                        selectedItem={eventTyp}
                                        name='eventType'
                                        setData={setEventType}
                                    />
                                </Col>
                            </Row>

                            <Row className="mt-3 align-items-end">
                                <Col md={12}>
                                    <label>Şəkil</label>
                                    <input name="imgUrl"
                                           id="upload"
                                           type="file"
                                           accept="image/jpeg,image/png,image/jpg,image/webp,image/gif"
                                           className="form-control shadow-none"
                                           onChange={(e) => {
                                               const file = e.target.files[0];
                                               setSelectedFile(file);
                                               UploadFile(file);
                                           }}
                                    />
                                </Col>
                            </Row>

                            <div className="mt-3">
                                <TextField label="Youtube Link" name="youtubeLink" type="text" enableLabel='true' />
                            </div>
                            <div className="mt-2">
                                <TextField label="Qiymət" name="price" type="text" enableLabel='true' />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button"
                                    className="btn btn-secondary"
                                    onClick={handleClose}>Bağla</button>
                            <button type="submit"
                                    onClick={() => {
                                        setSubmitClicked(true);
                                        setFileUploadClicked(false);
                                    }}
                                    className="btn btn-primary">Yadda Saxla</button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            )}
        </Formik>
    );
};

export default AddDataModal;
